import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_SEARCH_PHRASE_PRODUCTS = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}
  query GetSearchPhraseProducts(
    $searchPhrase: String
    $sortBy: SortBy!
    $page: Int!
    $pageSize: Int!
    $selectedFacets: [FacetParameterInput!]
  ) {
    productSearch(
      searchPhrase: $searchPhrase
      sortBy: $sortBy
      page: $page
      pageSize: $pageSize
      facets: $selectedFacets
      selectedCategoryPath: ""
      isUserInitiated: false
    ) {
      productReferences {
        ...ProductReference
      }
    }
  }
`
